<template>
    <div>
        <p>During this internship I lead an effort to build and deploy a machine learning model at production scale from the ground up. The purpose of this model was to predict the likelihood of a conversion from a lead to a customer provided a set of an individuals online interactions and behaviors.</p>
        <logo-scroller :logos="logos"><p>Tech used:</p></logo-scroller>
    </div>
</template>

<script>
    import LogoScroller from '@/components/LogoScroller'

    export default {
        name: "MachineLearningTimeline",
        components: {
            LogoScroller
        },
        data () {
            return {
                logos: [
                    'aws',
                    'sagemaker',
                    'docker',
                    'python',
                    'scikitlearn',
                    'numpy',
                    'pandas',
                    'matplotlib'
                ]
            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style>

</style>